import React from "react";
import "./HallsListLoading.component.scss";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

export const HallsListLoading = () => {
    return (
        <div className="halls-list-loading">
            <Components.LoadingRipple height={100} width={100} />
        </div>
    );
};
